/* global canBeEdited templateAssignUrl templateAssignUpdateUrl */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import TemplateAssign from '../templates/TemplateAssign';

function ExpenseLibraryTemplatesShow() {
    return (
        <div>
            <div className="row p-2">
                <div className="col">
                    <div id="TemplateAssign">
                        <TemplateAssign
                            cellW="160"
                            cellH="80"
                            dividerW="160"
                            dividerH="100"
                            editable="true"
                            templateAssignUrl={templateAssignUrl}
                            templateAssignUpdateUrl={templateAssignUpdateUrl}
                            templateAssignUpdateUrlMethod="PUT"
                            canBeEdited={canBeEdited === undefined ? true : !!canBeEdited}
                            forProcurement={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ExpenseLibraryTemplatesShow;
if (document.getElementById('ExpenseLibraryTemplatesShow')) {
    var rootEl = document.getElementById('ExpenseLibraryTemplatesShow');
    ReactDOM.render(
        <App>
            <ExpenseLibraryTemplatesShow />
        </App>,
        rootEl,
    );
}
